import React from 'react';
import { SIcon } from '@chargebee/sting-react';

export const ErrorPage: React.FC<{ message: string }> = ({ message }) => (
  <div className="container">
    <link
      rel="stylesheet"
      type="text/css"
      href="/assets/bootstrap/bootstrap-reboot.min.css"
    />
    <link rel="stylesheet" type="text/css" href="/assets/stylesheets/404.css" />
    <div className="error-template">
      <SIcon
        name="triangle-alert"
        size={80}
        className="warning tw-text-neutral-400"
      />
      <div className="h2">Uh oh!</div>
      <div className="error-details">{message}</div>
    </div>
  </div>
);
